import { lazy, Suspense, ReactNode } from 'react';

// Lazy load TooltipProvider - it's not needed for initial render
const TooltipProvider = lazy(() => 
  import('@/components/ui/tooltip').then(module => ({ 
    default: module.TooltipProvider 
  }))
);

interface LazyTooltipProviderProps {
  children: ReactNode;
}

/**
 * Wrapper that lazy loads TooltipProvider to reduce initial bundle
 * Tooltips aren't critical for LCP, so we defer loading
 */
export const LazyTooltipProvider = ({ children }: LazyTooltipProviderProps) => {
  return (
    <Suspense fallback={children}>
      <TooltipProvider>
        {children}
      </TooltipProvider>
    </Suspense>
  );
};
